import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d9e582a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-col-12 p-grid p-mr-0 p-ml-0 p-pb-0 p-pt-3" }
const _hoisted_2 = { class: "p-col-8 p-pl-0" }
const _hoisted_3 = { class: "headline p-component p-m-0" }
const _hoisted_4 = { class: "p-col-4 p-as-center p-grid p-jc-end" }
const _hoisted_5 = { class: "p-col-12 p-grid nested-grid p-m-0" }
const _hoisted_6 = { class: "p-col-12 p-text-bold" }
const _hoisted_7 = { class: "p-grid p-col-12" }
const _hoisted_8 = { class: "p-col-9" }
const _hoisted_9 = { class: "p-p-2 p-d-block" }
const _hoisted_10 = { class: "p-p-2" }
const _hoisted_11 = { class: "p-col-3 p-text-center p-as-center" }
const _hoisted_12 = { class: "p-grid p-col-12" }
const _hoisted_13 = { class: "p-col-9" }
const _hoisted_14 = { class: "p-p-2 p-d-block" }
const _hoisted_15 = { class: "p-p-2" }
const _hoisted_16 = { class: "p-col-3 p-text-center p-as-center" }
const _hoisted_17 = { class: "p-col-12 p-grid nested-grid p-m-0" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-col-12 p-text-bold" }, "Viewer", -1))
const _hoisted_19 = { class: "p-grid p-col-12" }
const _hoisted_20 = { class: "p-col-9" }
const _hoisted_21 = { class: "p-col-3 p-text-center" }
const _hoisted_22 = {
  key: 0,
  class: "p-grid p-col-12 p-ml-0"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "p-col-12",
  style: {"margin-left":"-0.5rem"}
}, "Highlighting", -1))
const _hoisted_24 = { class: "p-grid p-col-12" }
const _hoisted_25 = { class: "p-col-9" }
const _hoisted_26 = { class: "p-p-2 p-d-block" }
const _hoisted_27 = { class: "p-p-2" }
const _hoisted_28 = { class: "p-col-3 p-text-center p-as-center" }
const _hoisted_29 = {
  key: 0,
  class: "p-grid p-col-12"
}
const _hoisted_30 = { class: "p-col-9" }
const _hoisted_31 = { class: "p-p-2 p-d-block" }
const _hoisted_32 = { class: "p-p-2" }
const _hoisted_33 = { class: "p-col-3 p-text-center p-as-center" }
const _hoisted_34 = ["value"]
const _hoisted_35 = { class: "p-grid p-col-12" }
const _hoisted_36 = { class: "p-col-9" }
const _hoisted_37 = { class: "p-p-2 p-d-block" }
const _hoisted_38 = { class: "p-p-2" }
const _hoisted_39 = { class: "p-col-3 p-text-center p-as-center" }
const _hoisted_40 = {
  key: 1,
  class: "p-grid p-col-12"
}
const _hoisted_41 = { class: "p-col-9" }
const _hoisted_42 = { class: "p-p-2 p-d-block" }
const _hoisted_43 = { class: "p-p-2" }
const _hoisted_44 = { class: "p-col-3 p-text-center p-as-center" }
const _hoisted_45 = ["value"]
const _hoisted_46 = {
  key: 2,
  class: "p-grid p-col-12"
}
const _hoisted_47 = { class: "p-col-9" }
const _hoisted_48 = { class: "p-p-2 p-d-block" }
const _hoisted_49 = { class: "p-p-2" }
const _hoisted_50 = { class: "p-col-3 p-text-center p-as-center" }
const _hoisted_51 = { class: "p-grid p-col-12 p-ml-0" }
const _hoisted_52 = {
  class: "p-col-12",
  style: {"margin-left":"-0.5rem"}
}
const _hoisted_53 = { class: "p-grid p-col-12" }
const _hoisted_54 = { class: "p-col-9" }
const _hoisted_55 = { class: "p-p-2 p-d-block" }
const _hoisted_56 = { class: "p-p-2" }
const _hoisted_57 = { class: "p-col-3 p-text-center p-as-center" }
const _hoisted_58 = { class: "p-grid p-col-12" }
const _hoisted_59 = { class: "p-col-9" }
const _hoisted_60 = { class: "p-p-2 p-d-block" }
const _hoisted_61 = { class: "p-p-2" }
const _hoisted_62 = { class: "p-col-3 p-text-center p-as-center" }
const _hoisted_63 = { class: "p-grid p-col-12" }
const _hoisted_64 = { class: "p-col-9" }
const _hoisted_65 = { class: "p-p-2 p-d-block" }
const _hoisted_66 = { class: "p-p-2" }
const _hoisted_67 = { class: "p-col-3 p-text-center p-as-center" }
const _hoisted_68 = {
  key: 0,
  class: "p-grid p-col-12"
}
const _hoisted_69 = { class: "p-col-9" }
const _hoisted_70 = { class: "p-p-2 p-d-block" }
const _hoisted_71 = { class: "p-p-2" }
const _hoisted_72 = { class: "p-col-3 p-text-center p-as-center" }
const _hoisted_73 = { class: "p-grid p-col-12 p-jc-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_Slider = _resolveComponent("Slider")!
  const _component_DialogDelete = _resolveComponent("DialogDelete")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('Squeeze.UserSettings.ViewSettings.ViewSettings')), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Button, {
          class: "p-button p-button-rounded p-button-text",
          icon: "mdi mdi-close",
          onClick: _ctx.clickSettingDialog
        }, null, 8, ["onClick"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('Squeeze.UserSettings.ViewSettings.Validation')), 1),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('Squeeze.UserSettings.ViewSettings.TightValidationLayout')), 1),
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('Squeeze.UserSettings.ViewSettings.SpaceBetweenValidationFields')), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_InputSwitch, {
            modelValue: _ctx.userSettings.viewSettings.smallDistanceBetweenFields,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userSettings.viewSettings.smallDistanceBetweenFields) = $event)),
            onChange: _ctx.setUserSettings
          }, null, 8, ["modelValue", "onChange"])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('Squeeze.UserSettings.ViewSettings.FontSize')), 1),
          _createElementVNode("span", _hoisted_15, [
            _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.UserSettings.ViewSettings.FontSizeDescription')) + " ", 1),
            _createElementVNode("b", null, _toDisplayString(_ctx.userSettings.viewSettings.fontSize), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_Slider, {
            modelValue: _ctx.userSettings.viewSettings.fontSize,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userSettings.viewSettings.fontSize) = $event)),
            step: 0.025,
            min: 0.7,
            max: 1,
            onChange: _ctx.onChangeFontSize,
            onSlideend: _ctx.onSlideEnd
          }, null, 8, ["modelValue", "onChange", "onSlideend"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _hoisted_18,
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('Squeeze.UserSettings.ViewSettings.NewViewer')), 1),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_InputSwitch, {
            modelValue: _ctx.userSettings.viewSettings.v2Viewer,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userSettings.viewSettings.v2Viewer) = $event)),
            onChange: _ctx.setUserSettings,
            disabled: (!_ctx.store.state.featureSet.v2Viewer && _ctx.store.state.featureSet.v1Viewer) || (!_ctx.store.state.featureSet.v1Viewer && _ctx.store.state.featureSet.v2Viewer) || (!_ctx.store.state.featureSet.v1Viewer && !_ctx.store.state.featureSet.v2Viewer)
          }, null, 8, ["modelValue", "onChange", "disabled"])
        ])
      ]),
      (_ctx.store.state.featureSet.v2Viewer && _ctx.store.state.userSettings.viewSettings.v2Viewer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('Squeeze.UserSettings.ViewSettings.ViewerSettings.HighlightOptions.FillSelection')), 1),
                _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t('Squeeze.UserSettings.ViewSettings.ViewerSettings.HighlightOptions.FillSelectionDescription')), 1)
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createVNode(_component_InputSwitch, {
                  modelValue: _ctx.userSettings.viewSettings.viewerSettings.highlightOptions.draw,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.userSettings.viewSettings.viewerSettings.highlightOptions.draw) = $event)),
                  onChange: _ctx.onChangeDraw
                }, null, 8, ["modelValue", "onChange"])
              ])
            ]),
            (_ctx.userSettings.viewSettings.viewerSettings.highlightOptions.draw)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('Squeeze.UserSettings.ViewSettings.ViewerSettings.HighlightOptions.SelectionColor')), 1),
                    _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t('Squeeze.UserSettings.ViewSettings.ViewerSettings.HighlightOptions.SelectionColorDescription')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("input", {
                      type: "color",
                      value: _ctx.userSettings.viewSettings.viewerSettings.highlightOptions.drawColor,
                      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onChangeDrawColor($event.target.value))),
                      class: "input-color"
                    }, null, 40, _hoisted_34)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t('Squeeze.UserSettings.ViewSettings.ViewerSettings.HighlightOptions.Border')), 1),
                _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$t('Squeeze.UserSettings.ViewSettings.ViewerSettings.HighlightOptions.BorderDescription')), 1)
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createVNode(_component_InputSwitch, {
                  modelValue: _ctx.userSettings.viewSettings.viewerSettings.highlightOptions.border,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.userSettings.viewSettings.viewerSettings.highlightOptions.border) = $event)),
                  onChange: _ctx.onChangeBorder
                }, null, 8, ["modelValue", "onChange"])
              ])
            ]),
            (_ctx.userSettings.viewSettings.viewerSettings.highlightOptions.border)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.$t('Squeeze.UserSettings.ViewSettings.ViewerSettings.HighlightOptions.BorderColor')), 1),
                    _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t('Squeeze.UserSettings.ViewSettings.ViewerSettings.HighlightOptions.BorderColorDescription')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("input", {
                      type: "color",
                      value: _ctx.userSettings.viewSettings.viewerSettings.highlightOptions.borderColor,
                      onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onChangeBorderColor($event.target.value))),
                      class: "input-color"
                    }, null, 40, _hoisted_45)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.userSettings.viewSettings.viewerSettings.highlightOptions.border)
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.$t('Squeeze.UserSettings.ViewSettings.ViewerSettings.HighlightOptions.BorderStyle')), 1),
                    _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.$t('Squeeze.UserSettings.ViewSettings.ViewerSettings.HighlightOptions.BorderStyleDescription')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _createVNode(_component_InputSwitch, {
                      modelValue: _ctx.isBorderStyleDashed,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isBorderStyleDashed) = $event)),
                      onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onChangeBorderStyle(_ctx.isBorderStyleDashed)))
                    }, null, 8, ["modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_51, [
        _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.$t('Squeeze.UserSettings.ViewSettings.ViewerSettings.ZoomOptions.Zoom')), 1),
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.$t('Squeeze.UserSettings.ViewSettings.ViewerSettings.ZoomOptions.FullWidth')), 1),
            _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.$t('Squeeze.UserSettings.ViewSettings.ViewerSettings.ZoomOptions.FullWidthDescription')), 1)
          ]),
          _createElementVNode("div", _hoisted_57, [
            _createVNode(_component_InputSwitch, {
              modelValue: _ctx.userSettings.viewSettings.viewerSettings.zoomOptions.fullWidth,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.userSettings.viewSettings.viewerSettings.zoomOptions.fullWidth) = $event)),
              onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onChangeZoom('fullWidth')))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_58, [
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.$t('Squeeze.UserSettings.ViewSettings.ViewerSettings.ZoomOptions.FullHeight')), 1),
            _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.$t('Squeeze.UserSettings.ViewSettings.ViewerSettings.ZoomOptions.FullHeightDescription')), 1)
          ]),
          _createElementVNode("div", _hoisted_62, [
            _createVNode(_component_InputSwitch, {
              modelValue: _ctx.userSettings.viewSettings.viewerSettings.zoomOptions.fullHeight,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.userSettings.viewSettings.viewerSettings.zoomOptions.fullHeight) = $event)),
              onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onChangeZoom('fullHeight')))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_63, [
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.$t('Squeeze.UserSettings.ViewSettings.ViewerSettings.ZoomOptions.Custom')), 1),
            _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.$t('Squeeze.UserSettings.ViewSettings.ViewerSettings.ZoomOptions.CustomDescription')), 1)
          ]),
          _createElementVNode("div", _hoisted_67, [
            _createVNode(_component_InputSwitch, {
              modelValue: _ctx.userSettings.viewSettings.viewerSettings.zoomOptions.customZoom,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.userSettings.viewSettings.viewerSettings.zoomOptions.customZoom) = $event)),
              onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onChangeZoom('custom')))
            }, null, 8, ["modelValue"])
          ])
        ]),
        (_ctx.userSettings.viewSettings.viewerSettings.zoomOptions.customZoom)
          ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("span", _hoisted_70, _toDisplayString(_ctx.$t('Squeeze.UserSettings.ViewSettings.ViewerSettings.ZoomOptions.SliderValue')), 1),
                _createElementVNode("span", _hoisted_71, [
                  _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.UserSettings.ViewSettings.ViewerSettings.ZoomOptions.SliderValueDescription')) + " ", 1),
                  _createElementVNode("b", null, _toDisplayString(_ctx.userSettings.viewSettings.viewerSettings.zoomOptions.customSlider.toFixed(2)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_72, [
                _createVNode(_component_Slider, {
                  modelValue: _ctx.userSettings.viewSettings.viewerSettings.zoomOptions.customSlider,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.userSettings.viewSettings.viewerSettings.zoomOptions.customSlider) = $event)),
                  step: 0.05,
                  min: 0.5,
                  max: 1,
                  onSlideend: _ctx.onSlideEnd
                }, null, 8, ["modelValue", "onSlideend"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_73, [
      _createVNode(_component_Button, {
        label: _ctx.$t('Squeeze.UserSettings.RestoreDefaultViewerSettings'),
        class: "p-button-text p-button-plain",
        onClick: _ctx.openConfirmDialog
      }, null, 8, ["label", "onClick"])
    ]),
    _createVNode(_component_DialogDelete, {
      showDialog: _ctx.confirmDialog,
      onOnClose: _cache[16] || (_cache[16] = ($event: any) => (_ctx.confirmDialog = false)),
      headerLabel: _ctx.$t('Squeeze.UserSettings.RestoreDefaultViewerSettings'),
      messageLabel: _ctx.$t('Squeeze.UserSettings.MessageRestoreDefaultViewerSettings'),
      onOnConfirm: _ctx.setDefaultSettings
    }, null, 8, ["showDialog", "headerLabel", "messageLabel", "onOnConfirm"])
  ], 64))
}